import { type ApiClient, listQueryParams } from "./client";
import type { AppointmentFilters, AppointmentRow, ListQuery, Page } from "./types";

/** Appointments: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface AppointmentsApi {
  list(query: ListQuery<AppointmentFilters>): Promise<Page<AppointmentRow>>;
}

export function createHttpAppointmentsApi(client: ApiClient): AppointmentsApi {
  return {
    list: (q) => client.call("listAppointments", { query: listQueryParams(q) }),
  };
}
